<template>
    <div class="headingWrap row">
      <div class="headingWrap__title">
        <heading type="h1" name="slot">
          <slot name="title"></slot>
        </heading>
      </div>
      <div class="headingWrap__nav">
        <slot name="link"></slot>
      </div>
    </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'headingWrap',
  components: {
    Heading
  },
  props: {},
  mounted () {},
  data: () => ({})
}
</script>

<style lang="scss">
    .headingWrap {
      border-bottom: 1px solid #DDD;
      margin: 0 0 10px 0;
      display: flex;
      &__title {
        width: 50%
      }
      &__nav {
        width: 50%
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/HeadingWrap/heading-wrap.vue